import { AngularFireAuth } from '@angular/fire/auth';
import { FirestoreService } from 'common-lib';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class NoAuthGuard implements CanActivate {
  constructor(private auth: AngularFireAuth, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.auth.user.pipe(
      map(user => {
        if (!user || user.isAnonymous) {
          return true;
        }
        this.router.navigate(['/']);
        return false;
      })
    );
  }
}
